var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.011 5.99V4.384c0-.77.6-.955 1.035-.955h2.64V0H8.05C4.005 0 3.1 2.54 3.1 4.189V5.99H.75v4.005h2.374V20h4.71V9.995h3.482l.154-1.574.28-2.43H8.012z","fill":"currentColor","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"viewBox":"0 0 12 20","width":"12","height":"20"};

module.exports = Facebook;

Facebook.default = Facebook;
